import React from 'react';
import { Helmet } from 'react-helmet';


import ModelAdminDashboard from '../admin-dashboard/components/ModelAdminDashboard';

const ModelManagementPage = () => {
  return (
    <>
      <Helmet>
        <title>Gestion Modèles 3D — Administration</title>
        <meta name="description" content="Interface d'administration pour assigner des modèles GLB/OBJ aux propriétés, contrôler leur visibilité et suivre les métriques de performance." />
      </Helmet>
      <ModelAdminDashboard
        onBack={() => window.history?.back()}
      />
    </>
  );
};

export default ModelManagementPage;
